import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap";

import "./Navbar.css";
import { Springuplogo } from "../../theme/images";

const navigation = [
  { name: "Home", href: "/" },
  {
    name: "Our Approach",
    children: [
      { name: "Offshore Office", href: "/#challenges" },
      { name: "Engagement Models", href: "/engagement-models" },
      { name: "Process Driven Approach", href: "/process-driven-approach" },
      { name: "AI-COE", href: "/ai-coe" },
    ],
  },
  {
    name: "About",
    children: [
      { name: "About us", href: "/about" },
      { name: "Global Ecosystem", href: "/contact#global-offices" },
      { name: "Leadership", href: "/leadership" },
      { name: "Life @ SpringUp Labs", href: "/life-at-springup" },
    ],
  },
  {
    name: "Services",
    children: [
      { name: "AI Enabled GCC Services", href: "/services/gcc-services" },
      { name: "New Product Development", href: "/services/new-product-development" },
      { name: "Product Support Services", href: "/services/product-support-services" },
      { name: "Cloud Solutions", href: "/services/cloud-solutions" },
    ],
  },
  { name: "Careers", href: "/careers" },
  {
    name: "Insights",
    children: [
      { name: "Blogs", href: "/blogs" },
      { name: "Two Pager", href: "/SpringUpLabsTwoPager.pdf", isExternal: true, target: "_blank" },
      { name: "Case Study", href: "/insights/case-study" },
      { name: "Clients", href: "/clients" },
      { name: "Client Testimonies", href: "/client-testimonies" },
    ],
  },
];

function SpringUpNavbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const toggle = () => setIsOpen(!isOpen);

  // Scroll to top if already on the same page
  const handleNavClick = (to, e) => {
    setIsOpen(false);

    // Extract only the pathname part (ignore hash for comparison)
    const targetPath = to.split("#")[0] || "/";

    if (location.pathname === targetPath) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" }); // change to "auto" if you want instant
    }
  };

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Navbar
        expand="lg"
        fixed="top"
        className={`springup-main-navbar ${scrolled ? "scrolled" : ""}`}
      >
        <div className="springup-navbar-inner container">
          {/* LEFT: Logo */}
          <NavbarBrand
            tag={Link}
            to="/"
            className="springup-brand"
            onClick={(e) => handleNavClick("/", e)}
          >
            <div>
              <img
                src={Springuplogo}
                alt="SpringUp Labs"
                className="springup-logo-img"
              />
            </div>
          </NavbarBrand>

          <NavbarToggler onClick={toggle} className="springup-toggler" />

          {/* RIGHT SIDE CONTENT */}
          <Collapse isOpen={isOpen} navbar className="springup-right-content">
            <Nav className="springup-nav ms-auto" navbar>
              {navigation.map((item) =>
                item.children ? (
                  <UncontrolledDropdown nav inNavbar key={item.name}>
                    <DropdownToggle
                      nav
                      caret={false}
                      className="springup-nav-item springup-dropdown-toggle"
                    >
                      {item.name}
                    </DropdownToggle>
                    <DropdownMenu className="springup-dropdown">
                      {item.children.map((child) => (
                        <DropdownItem
                          key={child.name}
                          tag={child.isExternal ? "a" : Link}
                          href={child.isExternal ? child.href : undefined}
                          to={child.isExternal ? undefined : child.href}
                          className="springup-dropdown-item"
                          target={child.isExternal ? "_blank" : undefined}
                          rel={
                            child.isExternal ? "noopener noreferrer" : undefined
                          }
                          onClick={(e) => {
                            if (child.isExternal) {
                              setIsOpen(false);
                            } else {
                              handleNavClick(child.href, e);
                            }
                          }}
                        >
                          <span className="springup-dropdown-text">
                            {child.name}
                          </span>
                          <span className="springup-dropdown-arrow">→</span>
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                ) : (
                  <NavItem key={item.name}>
                    <NavLink
                      tag={Link}
                      to={item.href}
                      className="springup-nav-item"
                      onClick={(e) => handleNavClick(item.href, e)}
                    >
                      {item.name}
                    </NavLink>
                  </NavItem>
                )
              )}
            </Nav>

            <Button
              tag={Link}
              to="/contact"
              className="springup-contact-btn ms-3 ms-lg-4"
              onClick={(e) => handleNavClick("/contact", e)}
            >
              Contact Us
            </Button>
          </Collapse>
        </div>
      </Navbar>

      <div className="springup-navbar-spacer" />
    </>
  );
}

export default SpringUpNavbar;